import validator from 'validator';
import moment from "moment";
import axios from "axios";
import { validate as uuidValidate } from 'uuid';
// const CC = require('currency-converter-lt');
// const currencyConverter = new CC();

const getUrlVars = url => {
    var vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}

export default class {
    static isValidEmail = email => validator.isEmail(email)
    static rodalSmallVertical = () => {
        return {width: '25%', height: '80%', overflow: 'auto'};
    }
    static rodalSmallHorizontal = () => {
        return {width: '50%', height: '55%', overflow: 'auto'};
    }
    static rodalBig = () => {
        return {width: '80%', height: '80%', overflow: 'auto'};
    }

    static getUrlParam = (url, parameter, defaultvalue) => {
        let urlparameter = defaultvalue;
        if (url.indexOf(parameter) > -1) {
            urlparameter = getUrlVars(url)[parameter];
        }
        return urlparameter;
    }

    static bytesToSize = bytes => {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }

    static monthYearFormat = date => moment(date).format('MMM YYYY')
    static dayMonthYearFormat = date => moment(date).format('DD MMM YYYY')
    static getIp = async () => {
        const ipResponse = await axios.get(`https://api.ipify.org/?format=json`);
        const ip = ipResponse && ipResponse.data && ipResponse.data.ip || '';
        return ip;
    }

    static getCategories = c => {
		return c.split("|").join(", ");
	}

    // static formatToCurrency = amount => {
    //     return "€" + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", ""); 
    // }

    static formatToCurrency = (amount, currency) => {
        return currency + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", ""); 
    }

    // static convertCurrency = async (from, to, amount) => {
    //     const response = await currencyConverter.from(from).to(to).amount(amount).convert();
    //     console.log(response);
    //     return to + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", ""); 
    // }

    static formatSlider = (amount, symbol) => {
        if(amount === 3000) {
            return symbol + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "") + "+";
        }
        
        return symbol + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", ""); 
    }

    static formatToNumber = amount => {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", ""); 
    }

    static isValidUuid = uid => uuidValidate(uid)

    static getAudioDuration = (src, cb) => {
        const audio = new Audio(src);
        audio.addEventListener('loadedmetadata', function () {
            cb(parseFloat(audio.duration / 60).toFixed(2));
        });
    }

    static replaceAll = (oldString, newString, fullString) => {
        return fullString.split(oldString).join(newString)
    }
}